import styled from "styled-components";
import { BaseBotao, Botao } from "./Styled";

export const Button = (props) => {
  return (
    <BaseBotao>
      <Botao>Examinar</Botao>
    </BaseBotao>
  );
};
